var map = {
	"./botez1.jpeg": 4507,
	"./botez2.jpeg": 3758,
	"./botez3.jpeg": 4021,
	"./botez4.jpeg": 4896,
	"./botez5.jpeg": 8119,
	"./botez6.jpeg": 3482,
	"./events1.jpeg": 7930,
	"./events2.jpeg": 9863,
	"./events3.jpeg": 4080,
	"./events4.jpeg": 2517,
	"./events5.jpeg": 30,
	"./maj-bianca1.jpeg": 2070,
	"./maj-bianca10.jpeg": 562,
	"./maj-bianca2.jpeg": 4403,
	"./maj-bianca3.jpeg": 4140,
	"./maj-bianca4.jpeg": 3913,
	"./maj-bianca5.jpeg": 8050,
	"./maj-bianca6.jpeg": 8991,
	"./maj-bianca7.jpeg": 8472,
	"./maj-bianca8.jpeg": 6597,
	"./maj-bianca9.jpeg": 9982,
	"./majorate1.jpeg": 4616,
	"./majorate10.jpeg": 5784,
	"./majorate11.jpeg": 3679,
	"./majorate12.jpeg": 8898,
	"./majorate13.jpeg": 9529,
	"./majorate14.jpeg": 8300,
	"./majorate15.jpeg": 4979,
	"./majorate16.jpeg": 3494,
	"./majorate17.jpeg": 4829,
	"./majorate18.jpeg": 9088,
	"./majorate19.jpeg": 6135,
	"./majorate2.jpeg": 3353,
	"./majorate20.jpeg": 2311,
	"./majorate21.jpeg": 2736,
	"./majorate22.jpeg": 1361,
	"./majorate23.jpeg": 1322,
	"./majorate3.jpeg": 1618,
	"./majorate4.jpeg": 5091,
	"./majorate5.jpeg": 1004,
	"./majorate6.jpeg": 877,
	"./majorate7.jpeg": 2614,
	"./majorate8.jpeg": 4311,
	"./majorate9.jpeg": 2432,
	"./wed1.jpg": 3096,
	"./wed2.jpg": 1495,
	"./wed3.jpg": 7658,
	"./wed4.jpg": 8345,
	"./wed5.jpg": 300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6465;